import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="production-deploy"
export default class extends Controller {
  static targets = ['projectSelect', 'dateSelect', 'windowSelect'];
  static values = { userTimezone: String };

  connect() {
    console.log("ProductionDeployController connected");
    if (this.projectSelectTarget.value) {
      this.projectChanged({ target: this.projectSelectTarget });
    }
  }

  reconnect() {
    if (this.projectSelectTarget.value) {
      this.projectChanged({ target: this.projectSelectTarget });
    }
  }
  projectChanged(event) {
    const projectId = event.target.value;

    // Clear the date and window selects
    this.dateSelectTarget.innerHTML = '<option value="">Select Date</option>';
    this.windowSelectTarget.innerHTML = '<option value="">Select Window</option>';

    if (!projectId) return;

    fetch('/api/v1/production_deploys/available_deploy_dates_by_project', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ project_id: projectId })
    })
    .then(response => response.json())
    .then(data => {
      // Populate the date select with available dates
      data.available_dates.forEach(date => {
        const option = document.createElement('option');
        option.value = date;
        const [year, month, day] = date.split('-');
        const localDate = new Date(year, month - 1, day); // month is 0-indexed
        option.textContent = localDate.toLocaleDateString('en-US', {
          weekday: 'short',
          month: 'long',
          day: 'numeric'
        });
        this.dateSelectTarget.appendChild(option);
      });
    })
    .catch(error => {
      console.error('Error fetching deploy dates:', error);
    });
  }

  dateChanged(event) {
    const projectId = this.projectSelectTarget.value;
    const deployDate = event.target.value;

    // Clear the window select
    this.windowSelectTarget.innerHTML = '<option value="">Select Window</option>';

    if (!projectId || !deployDate) return;

    fetch('/api/v1/production_deploys/available_deploy_windows_by_project_and_date', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ project_id: projectId, deploy_date: deployDate, timezone: this.userTimezoneValue })
    })
    .then(response => response.json())
    .then(data => {
      // Populate the window select with available windows
      data.available_windows.forEach(window => {
        const option = document.createElement('option');
        option.value = window.id;
        option.textContent = window.name;
        this.windowSelectTarget.appendChild(option);
      });
    })
    .catch(error => {
      console.error('Error fetching deploy windows:', error);
    });
  }
}